var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[
    'lbz-tab',
    _vm.type && ("lbz-tab--" + _vm.type),
    _vm.type !== 'scrollable' && _vm.align && ("lbz-tab--" + _vm.align),
    _vm.onBackground && ("lbz-tab--on-" + _vm.onBackground),
    _vm.stacked && 'lbz-is-stacked'
  ]},[_c('div',{staticClass:"lbz-tab__container"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }